// React
import ReactDOM from 'react-dom';
import AddToCalendar from 'react-add-to-calendar';

var React = require('react');
var createReactClass = require('create-react-class');



if ( document.getElementById('addToCalendar') ) {

    const componentContainer = document.getElementById('addToCalendar');
  
    let title = componentContainer.dataset.title;
    let location = componentContainer.dataset.location;
    let startTime = componentContainer.dataset.start;
    let endTime = componentContainer.dataset.end;
    let icon = { 'fa fa-calendar-alt': 'left' };

    let event = {
        title: title,
        description: '',
        location: location,
        startTime: startTime,
        endTime: endTime
    };

    var add_calendar = ReactDOM.render(
        <AddToCalendar event={event} buttonLabel="Add to calendar" buttonTemplate={icon} />,
        document.getElementById('addToCalendar')
    );

}
